(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["crack-site-loader"] && !Shopify.designMode) return;
  try {
    const crackLoader = document.querySelector('[data-crack-site-loader]');
  if (crackLoader) {
    window.setTimeout(() => {
      crackLoader.classList.add('is-hidden');
    }, 1600);
  }
  } catch(e) { console.error(e); }
})();

})();
